import React, { useState, useEffect } from 'react';

import getNLS from '../../common/_NLS';


export default props=>{
    if (!props.me) return <></>;


    useEffect(() => {
        $('.informations div.article').css('height', "168px");  // 설명블럭 높이 초기화
        // console.log("줄수: ", $('.informations div.article').text().split('\n').length);
        if($('.informations div.article').text().split('\n').length > 10){
            console.log("10개넘는다.: ");            
            $('.informations .see-more-d').css('display', "block"); // 더 보기버튼 보이기로 초기화
        }else {
            $('.informations .see-more-d').css('display', "none");
        }
    }, [props.me.caption]);


        return (<div className="">
        <style jsx>{`

.article{
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 1.71;
    letter-spacing: -0.25px;

    height: 168px;
    min-height: 168px;
    overflow: hidden;

}

.see-more-d{
    width: 80px;
    margin: auto;
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: -0.25px;
    color: #495057;
}

.horizon-bar {
    width: 100%;
    height: 1px;
    margin:10px;
    background-color: #e9ecef;
}

.hashtag{
    font-size: 14px;
    line-height: 1.71;
    color: #55d5ce;
}
  
`}</style>
        <div className="article">
                {!props.me.caption ? '' : props.me.caption.split(/#[^# ]+[ ]/).join('')}
        </div>
            <a onClick={() => { 
                $('.informations div.article').css('height', "auto");
                $('.informations .see-more-d').css('display', "none");
            }}><div className="see-more-d" >+ {getNLS("더 보기")}</div>
        </a>
        <div className="">
            <div className="horizon-bar" />
        </div>
        <div className="">
            {/* lcg0816
            a,s,d 라고 입력하면 #a #d #s 라고나온다.
            AS-IS도 그렇다.
            pivot 정보가있지만 정렬에는 무쓸 */}
                {props.me.hashtags && props.me.hashtags.map((v,i)=>
                    <a key={i} className="hashtag" href={`/hashtag?kw=${v.name.substring(1)}`} > {v.name} </a>
            )}
        </div>
    </div>);
}
